import React, { createContext, useContext, useEffect, useState } from 'react';

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem('fosen_cart');
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem('fosen_cart', JSON.stringify(items));
  }, [items]);

  const addToCart = (product, qty = 1) => {
    const key = `${product.id}-${product.selectedVariantId || 'base'}`;
    setItems((prev) => {
      const found = prev.find((p) => (p.cartKey || `${p.id}-${p.selectedVariantId || 'base'}`) === key);
      if (found) {
        return prev.map((p) => ((p.cartKey || `${p.id}-${p.selectedVariantId || 'base'}`) === key ? { ...p, qty: p.qty + qty } : p));
      }
      return [...prev, { ...product, cartKey: key, qty }];
    });
  };

  const removeFromCart = (key) => setItems((prev) => prev.filter((p) => (p.cartKey || p.id) !== key));

  const updateQty = (key, qty) => {
    if (qty <= 0) return removeFromCart(key);
    setItems((prev) => prev.map((p) => ((p.cartKey || p.id) === key ? { ...p, qty } : p)));
  };

  const clearCart = () => setItems([]);

  const total = items.reduce((sum, i) => sum + i.price * i.qty, 0);
  const count = items.reduce((sum, i) => sum + i.qty, 0);

  return (
    <CartContext.Provider value={{ items, addToCart, removeFromCart, updateQty, clearCart, total, count }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
